import { Dispatch, createContext } from "react";

 
export type UserState = {
  user: any;
  error: any;
  beneficiary: any;
  loading: boolean;
  isVerified: boolean;
  isAuth: boolean;
  isAuthLoading: boolean;
  isCompleted: boolean;
  isLoggedIn: boolean;
  isReset: boolean;
};
export interface IContext {
  user: UserState;
  getUser: any;
  createUser: any;
  verifyOtp: any;
  updateUser: any;
  resetPassword: any;
  updateNewPassword: any;
  userDispatch: Dispatch<any>;
}
export const initialState = {};

const UserContext = createContext(initialState as IContext);

export default UserContext;
